export default "__VITE_ASSET__2e076090__"